import { useState } from 'react';
import { Link } from "react-router-dom";
import EsgChart from "../../components/Esg/EsgChart"
import EsgMobile from "../../components/Esg/EsgMobile"

const EsgPageMore3 = () => {
    const bgUrl = "https://res.cloudinary.com/dzngpgki4/image/upload/v1745435238/image_25_xv0dir.png";

    const [searchTerm, setSearchTerm] = useState("");
    const images = [
        { id: 1, head: "RESOURCE CENTRE", description: "Community HUB for accessing rsources ", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745435236/image_26_wd7cjb.png" },
        { id: 2, head: "DEVELOPMENT", description: "Develop your farm", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745435236/image_26_wd7cjb.png" },
        { id: 3, head: "SEED PROPERGATION", description: "Provide quality seeds", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745435236/image_26_wd7cjb.png" },
        { id: 4, head: "DEVELOPMENT", description: "Develop your farm", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745435236/image_26_wd7cjb.png" },
    ];
      
      const filteredImages = images.filter((image) =>
        image.head.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
    const community = {
        title: "Afrika Community",
        location: "Nyika, Country",
        farmerCount: "12,001",
        category: "Fruits & Vegetables",
        code: "FNZACO123456",
        rating: "4.3",
        reviews: "653",
    };
    return (
        <div className='bg-white'>
            <div className='md:pt-6 pt-3'>
                <div className='md:px-24 px-4 '>
                    <div className="flex justify-between items-center mb-4">
                        <a >
                            <h1 className="text-[#FDBD26] font-bold text-[12px] md:text-[36px]">GOVERNANACE |<span className='text-[#979797]'> AFRIKA COMMUNITY</span></h1>
                        </a>
                        <h1 className="text-black font-normal text-[10px] md:text-[36px]">{community.code}</h1>
                    </div>
                    <div className="relative w-full h-[180px] md:h-[622px] rounded-[10px] overflow-hidden mb-6">
                        <img src={bgUrl} alt="Community" className="w-full h-full object-cover" />
                        <div className="absolute bottom-4 md:bottom-8 left-4 md:left-3 text-white">
                            <h2 className="font-bold text-[12px] md:text-[32px]">🌳 "Our Forest, Our Future – Conserved by Community!"</h2>
                            <p className="text-[10px] md:text-[24px] md:ml-10">Community imitative on forest conservation</p>
                        </div>
                    </div>
                </div>
                <div className='md:px-24 px-4 '>
                    <h1 className=" text-[#979797] font-bold text-[12px] md:text-[40px]">GOVERNANACE  | <span className='text-[#FDBD26]'> DIGITAL ACCOUNTABILITY</span></h1>
                    <div className="md:mt-4 mt-3 text-[8px] md:text-[32px] text-black leading-relaxed">
                        <p>
                        FarmNet strengthens governance in farming communities by promoting transparency, accountability, and inclusive decision-making. Through digital record-keeping, traceable transactions, and support for farmer-led groups, the app empowers farmers to adopt responsible practices, comply with standards, and build trust with markets, investors, and development partners.
                        </p>
                    </div>
                    <h1 className=" text-black font-bold text-[12px] md:mt-14 md:text-[36px]">What we are doing</h1>
                    <div className="md:mt-4 mt-3 text-[8px] md:text-[32px] text-black leading-relaxed">
                        <p>
                        FarmNet is advancing Governance for ESG by helping farmers adopt transparent, ethical, and accountable practices. Through its digital platform, FarmNet enables farmers to keep accurate records, form organized groups, and engage in traceable transactions. This strengthens farmer leadership, supports compliance with sustainability standards, and builds trust with buyers, investors, and stakeholders—ensuring responsible governance across the agricultural value chain.
                        </p>
                    </div>
                    <div className=" mt-5 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-2">
                        {filteredImages.map((image) => (
                            <Link
                                key={image.id}
                                to={
                                    image.id === 1 ? "/comms" :

                                        image.id === 2 ? "/comms" :
                                            image.id === 3 ? "/comms" :
                                                image.id === 4 ? "/comms" :
                                                    image.id === 5 ? "/comms" :
                                                        image.id === 6 ? "/comms" :
                                                            image.id === 7 ? "/commsn" :
                                                                image.id === 8 ? "/comms" :
                                                                    `/comms/${image.id}`
                                }
                                className="flex flex-col rounded-lg"
                            >
                                <div className="relative w-full">
                                    <img
                                        src={`${image.img}`}
                                        alt={image.name}
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                </div>

                                <div className=" flex justify-between items-center bg-[#F1F1F1] md:py-6 md:px-8">
                                    <div>
                                        <p className="text-left font-bold text-[10px] md:text-[20px]">{image.head}</p>
                                        <p className="text-left font-normal text-[8px]  md:text-[20px] md:-mt-1 md:-mb-1 mb-2">{image.description}</p>
                                    </div>
                                </div>

                            </Link>

                        ))}
                    </div>
                    <h1 className=" text-black font-bold text-[12px] md:mt-2 md:text-[36px]">Result</h1>
                    <div className="text-[8px] md:text-[32px] text-black leading-relaxed">
                        <p>
                        Through FarmNet, over 10,000 farmers have adopted digital record-keeping and transparent reporting practices, leading to improved accountability, stronger cooperative leadership, and increased access to certified markets and financial services.
                        </p>
                    </div>
                </div>
                <div className='md:px-24 px-2 md:mt-10 '>
    <div className='md:block hidden'>
    <EsgChart />
    </div>
<div className='md:hidden block'>
    <EsgMobile/>
</div>
                </div>
                <div className='md:px-24 px-4 '>
            <div>
            <h1 className=" text-black font-bold text-[12px] md:-mt-8 md:text-[36px]">What are we looking for</h1>
                    <div className="md:mt-4 mt-3 text-[8px] md:text-[40px] text-black leading-relaxed">
                        <p>
                        We are raising USD 24,000 support to expand include more farmers to adopt digital record keeping .
                        </p>
                    </div>
            </div>
            <div className="flex justify-between items-start md:mt-12 mt-3">
          <div></div> {/* Empty div to push the button to the right */}

<div>
            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
              <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[240px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
              ADOPT-A-FARM
              </p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745429488/Expand_right_4_yccnyz.png"
                alt="Expand"
                className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
              />
            </div>
            
          </div>
        </div>
<div className="flex justify-between  items-center border-b border-[#979797] md:mt-20 md:py-10  py-2 md:px-5 px-3 md:space-x-5 flex-wrap rounded-md shadow-lg">
        <div className="text-left text-xl sm:text-xl lg:text-2xl font-semibold">
          <h1 className='font-bold text-[10px] md:text-[32px] '>SDG No 13</h1>
          <h1 className="md:mt-3  -mt-4 text-[6px] md:text-[32px] font-medium">Take urgent action to combat climate change and its impacts</h1>
        </div>
        <div className="md:w-20">
          <img src='https://res.cloudinary.com/dzngpgki4/image/upload/v1745280679/image_44_ircbsd.png' alt="Climate Action" className="md:w-full md:h-auto w-[20px] h-[20px]" />
        </div>
      </div>
      <div className='md:h-5 h-2'></div>

                </div>
            </div>
        </div>
    )
}

export default EsgPageMore3